/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, inject, h, watch, onMounted, onUnmounted, createVNode } from 'vue';
import { ANCHOR_SHARP_REGEXP } from './utils.mjs';
import props from './anchor-item-props.mjs';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import { AnchorInjectionKey } from './constants.mjs';
import { i as isFunction_1 } from '../_chunks/dep-8d19eb1a.mjs';
import { i as isString_1 } from '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var localProps = _objectSpread(_objectSpread({}, props), {}, {
  href: {
    type: String,
    required: true,
    validator: function validator(v) {
      return ANCHOR_SHARP_REGEXP.test(v);
    }
  }
});
var _AnchorItem = defineComponent({
  name: "TAnchorItem",
  inject: {
    tAnchor: {
      "default": void 0
    }
  },
  props: localProps,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var anchor = inject(AnchorInjectionKey, void 0);
    var CLASSNAME_PREFIX = usePrefixClass("anchor__item");
    var _useCommonClassName = useCommonClassName(),
      STATUS = _useCommonClassName.STATUS;
    var register = function register() {
      anchor.registerLink(props2.href);
    };
    var unregister = function unregister() {
      var href = props2.href;
      if (!href) return;
      anchor.unregisterLink(href);
    };
    var handleClick = function handleClick(e) {
      var href = props2.href,
        title = props2.title;
      anchor.handleScrollTo(href);
      anchor.handleLinkClick({
        href: href,
        title: isString_1(title) ? title : void 0,
        e: e
      });
    };
    var renderTitle = function renderTitle() {
      var title = props2.title;
      var titleSlot = slots.title;
      var titleVal;
      if (isString_1(title)) {
        titleVal = title;
      } else if (isFunction_1(title)) {
        titleVal = title(h);
      } else if (titleSlot) {
        titleVal = titleSlot(null);
      }
      return titleVal;
    };
    watch(function () {
      return props2.href;
    }, function () {
      unregister();
      register();
    }, {
      immediate: true
    });
    onMounted(function () {
      register();
    });
    onUnmounted(function () {
      unregister();
    });
    return function () {
      var _wrapperClass;
      var href = props2.href,
        target = props2.target;
      var children = slots["default"],
        titleSlot = slots.title;
      var title = renderTitle();
      var titleAttr = isString_1(title) ? title : null;
      var active = anchor.active === href;
      var wrapperClass = (_wrapperClass = {}, _defineProperty(_wrapperClass, CLASSNAME_PREFIX.value, true), _defineProperty(_wrapperClass, STATUS.value.active, active), _wrapperClass);
      var titleClass = _defineProperty({}, "".concat(CLASSNAME_PREFIX.value, "-link"), true);
      return createVNode("div", {
        "class": wrapperClass
      }, [createVNode("a", {
        "href": href,
        "title": titleAttr,
        "class": titleClass,
        "target": target,
        "onClick": handleClick
      }, [titleSlot ? titleSlot(null) : title]), children && children(null)]);
    };
  }
});

export { _AnchorItem as default };
//# sourceMappingURL=anchor-item.mjs.map
